import { BASE_URL } from "../../constans/ApiEndpointConstants";
import * as PixelEventAPI from "../../apis/PixelEventAPI";

// 调用 addevent 接口
const url = BASE_URL.replace("https://", "");
const getDonationAd = () => {
  const raw = localStorage.getItem("donation_ad");
  if (!raw) return "donation";
  try {
    return JSON.parse(raw) || "donation";
  } catch (e) {
    // Some callers store plain strings; fall back to the raw value
    return raw || "donation";
  }
};
const ad = getDonationAd();

var addEvents = (eventName, eventid) => {
  PixelEventAPI.addevent(url, ad, eventName, eventid)
    .then((res) => {
      console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

export const PixelWithEvent = (eventName, eventid) => {
  // 触发 ReactPixel 事件
  if (eventName !== "pageView") {
    addEvents(eventName, eventid);
  }
};
